export default __webpack_public_path__ + "static/media/olu-eletu.429cd6ef.jpg";